// Simple hover/focus based prefetching of lazy route chunks
// Usage: call initRoutePrefetch() once (e.g., in PageLayout or App useEffect)
// Elements with data-prefetch="/route" will trigger a dynamic import after a short delay

const routeImportMap = {
  '/associations': () => import('../pages/Associations/Associations'),
  '/pipeline': () => import('../components/PipelineBoard'),
  '/deal-setup': () => import('../pages/DealSetup/DealSetup'),
  '/reporting': () => import('../pages/Reporting/Reporting'),
  '/reporting/sales-dashboard': () => import('../pages/Reporting/SalesDashboard'),
  '/action-items': () => import('../pages/ActionItems/ActionItems'),
};

let initialized = false;

export function initRoutePrefetch(root = document) {
  if (initialized) return;
  initialized = true;
  const handler = e => {
    const el = e.target.closest('[data-prefetch]');
    if (!el) return;
    const route = el.getAttribute('data-prefetch');
    if (route && routeImportMap[route]) {
      // Debounce via short timeout to avoid accidental hovers
      if (el.__pfTimer) clearTimeout(el.__pfTimer);
      el.__pfTimer = setTimeout(() => {
        if (!el.__prefetched) {
          routeImportMap[route]().catch(() => {});
          el.__prefetched = true;
        }
      }, 120);
    }
  };
  root.addEventListener('mouseover', handler);
  root.addEventListener('focusin', handler);
}

export default initRoutePrefetch;
